import { useEffect, useState } from 'react';

export const useCountdown = (targetDate: string) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      const diff = countDownDate - new Date().getTime();
      setCountDown(diff);
      if (diff < 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (ms: number) => {
  const days = String(~~(ms / (1000 * 60 * 60 * 24))).padStart(2, '0');
  const hours = String(~~((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
  const minutes = String(~~((ms % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
  const seconds = String(~~((ms % (1000 * 60)) / 1000)).padStart(2, '0');
  return { days, hours, minutes, seconds, ms: ms > 1000 ? ms : 0 };
};
